export const IMAGE_TOOL_ID = 'afbeelding';
